import setImageOptions from "app/media/helpers/setImageOptions";
import { UmbracoImage } from "app/media/models/media.interface";
import isBrowserContext from "helpers/isBrowserContext";
import isDevelopment from "helpers/isDevelopment";
import { SiteSetting } from "../models/settings.model";
import { PAGE_TYPE } from "../pages/page.types";

/* Getting meta data for head from page content */
interface PageMeta {
    language: string;
    metaTitle: string;
    metaDescription: string;
    metaKeywords: string;
    metaCanonical: string;
    robots: string;
    socialTitle: string;
    socialDescription: string;
    socialImage: string;
    url: string;
    siteName: string;
}

const getImageUrl = (umbracoImage?: UmbracoImage): string | undefined => {
    if (umbracoImage && umbracoImage.umbracoFile) {
        const crop = umbracoImage.umbracoFile.crops?.find((crop) => crop.alias === "Square (1:1)");
        return setImageOptions(umbracoImage.umbracoFile.src, 1280, umbracoImage.umbracoExtension, crop, umbracoImage.umbracoFile.focalPoint, 1);
    } else {
        return undefined;
    }
};

const isProductionHost = (page: any): boolean => {
    if (isDevelopment()) {
        return false;
    } else if (page._url && page._url.indexOf("heyday.dk") > 0) {
        return false;
    } else if (isBrowserContext() && window.location.host.indexOf("heyday") > 0) {
        return false;
    }

    return true;
};

export default (page: PAGE_TYPE, settings: SiteSetting): PageMeta => {
    let language = "";
    let metaTitle = "";
    let metaDescription = "";
    let metaKeywords = "";
    let metaCanonical = "";
    let robots = "";
    let socialTitle = "";
    let socialDescription = "";
    let socialImage = "";
    let url = "";
    let siteName = "";

    if (page) {
        switch (page._contentType) {
            case "homePage":
            case "contentPage":
            case "blogPage":
            case "rootPage":
            case "notFoundPage": {
                language = page._culture || "da-dk";
                metaTitle = page.metaTitle || page._name || "REKOM";
                metaDescription = page.metaDescription || "";
                metaKeywords = page.metaKeywords || "";
                metaCanonical = page.canonical || page._url || "";
                robots = !isProductionHost(page)
                    ? "noindex, nofollow"
                    : `${page.metaAllowIndexingCulture === true ? "index" : "noindex"},${page.metaAllowFollowingCulture === true ? "follow" : "nofollow"}`;
                socialTitle = page.socialTitle || page.metaTitle || settings?.fallbackSocialTitle || page._name || "REKOM";
                socialDescription = page.socialDescription || page.metaDescription || settings?.fallbackSocialDescription || "";
                socialImage = getImageUrl(page.socialImage) || getImageUrl(page.socialImageTwo) || "";

                url = page._url || `${window.location.origin}${window.location.pathname}`;
                siteName = page?.metaSiteName || settings?.theme?.siteName || "REKOM";
                break;
            }
        }
    }

    // TODO: Make a prettier return type
    return {
        language: language,
        metaTitle: metaTitle,
        metaDescription: metaDescription,
        metaKeywords: metaKeywords,
        metaCanonical: metaCanonical,
        robots: robots,
        socialTitle: socialTitle,
        socialDescription: socialDescription,
        socialImage: socialImage,
        url: url,
        siteName: siteName,
    };
};
